<template>
  <div class="login">
    <div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
      <div class="card card0 border-3" style="border-radius:10px;">
        <div class="row d-flex">
          <div class="col-lg-7">
            <div class="card1 pb-5">
              <div class="row">
                <img src="/logo.png" class="logo" />
              </div>
              <div class="row px-3 justify-content-center mt-4 mb-5">
                <img src="/nuta.png" class="image" style="padding-top:100px" />
              </div>
            </div>
          </div>
          <div class="col-lg-5 border-line">
            <form @submit.prevent="selectOutlet">
              <div class="card2 card border-0 px-4 py-5">
                <div class="row">
                  <div class="col-lg-12 text-center">
                      <h4><b>LOGIN</b></h4>
                  </div>
                </div>
                <div class="row py-13" style="padding-top:10%;padding-left:5%">
                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#00ae2b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">1</div>
                  
                  <div class="col-4" style="margin:10px 3% 10px 3%;border-top: 3px solid #9b9b9b;"></div>

                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#00ae2b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">2</div>

                  <div class="col-4" style="margin:10px 3% 10px 3%;border-top: 3px solid #9b9b9b;"></div>
                  
                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#00ae2b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">3</div>
                </div>

                <div class="row" style="padding-top:10%">
                  <label class="col-lg-12 text-center">
                    Silahkan isikan berikut untuk login ke kasir Nutacloud
                  </label>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label class="floating-custom">Pilih Outlet</label>
                      <select v-if="listOutlet.length > 0" class="form-control" :required="true" v-model="form" name="OutletID">
                        <option v-for="option in listOutlet" v-bind:key="option.outletid" v-bind:value="option">
                          {{ option.outletname }}  {{option.outletaddress}}
                        </option>
                      </select>
                      <select v-else class="form-control" :required="true" v-model="form" name="OutletID">
                      <option v-bind:key="0">
                        Tidak ada data outlet di perusahaan
                      </option>
                      </select>
                      <i v-if="errors"><small class="text-danger">{{ errors }}</small></i>
                    </div>
                  </div>  
                </div>
                <div class="row mb-7" style="padding-top:25%">
                  <label class="col-2 control-label-bold col-4 text-green" style="margin-top:9px;text-align: left !important;" @click="$router.go(-1)">
                    Kembali
                  </label>
                  <button type="submit" class="col-4 btn btn-green text-center" style="border-radius:5px; margin-left:30%" :disabled="submitted">
                    <span v-html="btnPilih"></span>
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <ExpiredModal2 />
    <SaldoModal />
  </div>
</template>

<script>
/* eslint-disable */ //disabled eslint compiler
import { mapGetters, mapActions } from "vuex";
import $ from 'jquery';
import ExpiredModal2 from "@/components/konfirmasi_modal/ExpiredModal2.vue";
import SaldoModal from "@/components/konfirmasi_modal/SaldoModal.vue";

export default {
  name: "SelectingOutlet",
  data() {
    return {
      form: [],
      submitted: false,
      errors: null,
      btnPilih:"Login"
    };
  },
  components: {
    ExpiredModal2,
    SaldoModal
  },
  computed: {
    ...mapGetters(["listOutlet"]),
  },
  methods: {
    ...mapActions(["selectedOutlet"]),
    selectOutlet() {
      this.submitted = true;
      this.btnPilih = "<div class='fa fa-circle-notch fa-spin'></div>";
      this.$store
        .dispatch("selectedOutlet", this.form)
        .then((response) => {
          if (response.status == "OK") {
            this.submitted = false;
            this.$router.push({name: 'Download Data'})
          } else {
            console.log(response.message)
            if (response.message=="NONAKTIF"){
                $("#modalExpired2").modal("show")
                this.submitted = false;
            }
            else if(response.message=="SALDO TIDAK CUKUP"){
              $("#modalSaldo").modal("show")
                this.submitted = false;
            }
            else{
              this.errors = response.message;
              this.submitted = false;
            }
          }
          this.btnPilih = "Login";
        })
        .catch((error) => {
          this.btnPilih = "Login";
          this.errors = error.statusText;
          this.submitted = false;
        });
    },
  },
};
</script>
<style scoped>
body {
  color: #000;
  overflow-x: hidden;
  height: 100%;
  background-repeat: no-repeat;
}

.card0 {
  box-shadow: 0px 3px 8px 0px #757575;
  border-radius: 0px;
}

.card2 {
  margin: 0px 40px;
}

.logo {
  width: 150px;
  height:30px;
  transform: translateX(30px) translateY(21px);
}

.image {
  width: 650px;
  height: auto;
}

.border-line {
  border-left: 1px solid #eeeeee;
  margin-top:10px;
  margin-bottom:10px;
}

.or {
  width: 10%;
  font-weight: bold;
}

input,
textarea {
  padding: 10px 12px 10px 12px;
  border: 1px solid rgb(148, 148, 148);
  border-radius: 2px;
  margin-bottom: 5px;
  margin-top: 2px;
  width: 100%;
  box-sizing: border-box;
  color: #000000;
  font-size: 14px;
  letter-spacing: 1px;
}

input:focus,
textarea:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 1px solid #00ae2b;
  outline-width: 0;
}

button:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline-width: 0;
}

a {
  color: inherit;
  cursor: pointer;
}

.btn-green {
  background-color: #00ae2b;
  width: 150px;
  color: #fff;
  border-radius: 2px;
}

.btn-green:hover {
  background-color: #019b28;
  cursor: pointer;
}
.floating-custom {
    font-size: 14px;
    transform: translateY(95%) translateX(10%);
    background:#fff;
}
@media screen and (max-width: 991px) {
  .logo {
    margin-left: 0px;
  }

  .image {
    width: 300px;
    height: 220px;
  }

  .border-line {
    border-right: none;
  }

  .card2 {
    border-top: 1px solid #eeeeee !important;
    margin: 0px 15px;
  }
}
</style>